import React, { useCallback, useState, useRef, useEffect } from 'react';
import axios from '../axios';
import FeedItem from '../userfeeds/userfeed_item';

const UserfeedColumn = ({ column, currentUser, companyId, hashedCompanyId, hasDepartments }) => {
  const [userfeeds, setUserfeeds] = useState([]);
  const [isLoadingNextList, setIsLoadingNextList] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLastPage, setIsLastPage] = useState(false);
  const [isMobileDisplay, setIsMobileDisplay] = useState(window.innerWidth <= 768);
  const scrollRef = useRef(null);
  const ancLastItemRef = useRef(null);
  const isEnableNextLoad = useRef(true);

  const mdWidth = 768;

  const updateIsMobileDisplay = useCallback(() => {
    setIsMobileDisplay(window.innerWidth <= mdWidth);
  }, [setIsMobileDisplay]);

  useEffect(() => {
    window.addEventListener('resize', updateIsMobileDisplay);

    return () => {
      window.removeEventListener('resize', updateIsMobileDisplay);
    };
  }, [updateIsMobileDisplay]);

  const loadNextList = useCallback(() => {
    if (isLoadingNextList || isLastPage) {
      return;
    }

    setIsLoadingNextList(true);

    let url = '';
    if (column === 'all') {
      url = `/api/userfeeds/community_all?company_id=${companyId}&page=${currentPage}`;
    } else if (column === 'circle') {
      url =`/api/userfeeds/community/circles?company_id=${companyId}&page=${currentPage}`
    } else if (column === 'department') {
      url = `/api/userfeeds/community/departments?company_id=${companyId}&page=${currentPage}`  
    } else if (column === 'active') {
      url = `/api/userfeeds/community/active?company_id=${companyId}&page=${currentPage}`
    }

    axios.get(url).then((res) => {
      setUserfeeds((prev) => [...prev, ...res.data.userfeeds]);
      setCurrentPage((prev) => prev + 1);
      setIsLastPage(res.data.isLastPage);
    }).finally(() => {
      setIsLoadingNextList(false);
    });
  }, [currentPage, isLoadingNextList, isLastPage, setIsLoadingNextList, companyId]);

  useEffect(() => {
    loadNextList();
  }, []);

  const handleScrollEvent = useCallback(() => {
    if (!ancLastItemRef.current) {
      return;
    }
    
    const ancPosition = ancLastItemRef.current.offsetTop;
    const scrolled = scrollRef.current.scrollTop;

    if (
      scrolled > ancPosition - 1000 &&
      scrolled < ancPosition &&
      isEnableNextLoad.current
    ) {
      isEnableNextLoad.current = false;
      loadNextList();
    }
  }, [ancLastItemRef, isEnableNextLoad, loadNextList]);

  useEffect(() => {
    if (isLoadingNextList) {
      isEnableNextLoad.current = false;
    } else {
      isEnableNextLoad.current = true;
    }

    if (typeof scrollRef.current !== 'undefined') {
      if (isLastPage) {
        scrollRef.current.removeEventListener('scroll', handleScrollEvent);
      } else {
        scrollRef.current.addEventListener('scroll', handleScrollEvent);
      }

      return () => {
        scrollRef.current.removeEventListener('scroll', handleScrollEvent);
      };
    }
  }, [isLastPage, handleScrollEvent]);

  return (
    <div className={`p-2 ${hasDepartments ? 'col-md-3' : 'col-md-4'}`}>
      <div className="text-fz-10 d-none d-md-block text-gray bg-light font-weight-bold pl-4 py-3" style={{ fontSize: '0.75rem' }}>
        {column === 'all' ? 'すべて' : column === 'circle' ? 'サークル' : column === 'department' ? '部署' : '参加中'}
      </div>
      <div
        id="scroll"
        ref={scrollRef} 
        style={{ 
          height: `${isMobileDisplay ? 'calc(100vh - 240px)' : 'calc(100vh - 200px)'}`, 
          overflowY: 'scroll', 
          background: '#f8f9fa'
        }}>
        {userfeeds.map((userfeed, index) => (
          <FeedItem
            key={`${userfeed.id}_${index}`}
            currentUser={currentUser}
            userfeed={userfeed}
            hashedCompanyId={hashedCompanyId}
          />
        ))}
        {isLoadingNextList && (
          <div className="d-flex mx-auto py-4 align-items-center justify-content-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        <div id="ancLastItemRef" ref={ancLastItemRef} />
      </div>
    </div>
  )
};


export default UserfeedColumn;